import keycloak from "@/Keycloak";
import posthog from "posthog-js";

// Chrome extension ID for Getcrux extension
const EXTENSION_ID = import.meta.env.VITE_EXTENSION_ID as string;

/**
 * Emit logout event to Chrome extension if available
 */
const emitLogoutToExtension = (reason?: string) => {
  try {
    // Send logout event to the Chrome extension
    window.chrome?.runtime?.sendMessage(
      EXTENSION_ID,
      {
        action: "logout",
        reason: reason || "unknown",
      },
      () => {
        // Ignore errors - extension might not be listening or installed
        if (window.chrome?.runtime?.lastError) {
          console.debug(
            "Failed to send logout event to extension:",
            window.chrome?.runtime?.lastError,
          );
          // Extension not available or not listening, which is fine
        }
      },
    );
  } catch (error) {
    // Silently fail if extension messaging fails
    console.debug("Failed to send logout event to extension:", error);
  }
};

/**
 * Common logout function that handles both Keycloak and PostHog cleanup
 * @param reason - Optional reason for logout (e.g., "manual", "session_expired", "401_error")
 */
export const logout = (reason?: string) => {
  // Emit logout event to Chrome extension
  console.log("Sending logout event to extension");
  emitLogoutToExtension(reason);

  // Capture logout event with sendBeacon transport for reliability during page unload
  posthog.capture(
    "user_logout",
    {
      reason: reason || "unknown",
    },
    {
      transport: "sendBeacon",
    },
  );

  // Reset PostHog and perform logout immediately since sendBeacon is reliable
  posthog.reset();
  void keycloak.logout({ redirectUri: window.location.origin });
};

// Export as default
export default logout;
